import { ChakraProvider } from '@chakra-ui/react';
import AppRoutes from './routes/AppRoutes';
import ErrorBoundary from './components/ErrorBoundary';
import theme from './theme';
import './App.css';

function App() {
	return (
		<ChakraProvider theme={theme}>
			<ErrorBoundary>
				<AppRoutes />
			</ErrorBoundary>
		</ChakraProvider>
	);
}

export default App;
